import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { withWizard } from '@cimpress-technology/ff-react-components/lib/Wizard';
import StepTitle from '../../../common/StepTitle';
import WizardNavigator from '../../../common/WizardNavigator';
import { css } from 'react-emotion';
import Button from '../../../common/Button';
import isEqual from 'lodash/isEqual';
import ShippingTermCard from './ShippingTermCard';

const singleCard = css`
  margin: 0 auto;
  max-width: 600px;
`;

class SetupShippingPricingTermStep extends PureComponent {
  state = {
    termInfo: {},
    termHasValidationError: null
  };

  componentDidUpdate(prevProps, prevState) {
    const { termInfo } = this.state;
    if (!isEqual(prevState.termInfo, termInfo)) {
      const { onChange } = this.props;
      onChange({ shippingPricingTerm: termInfo });
    }
  }

  onPrev = () => {
    const { wizard } = this.props;
    wizard.setStep(wizard.previous);
  };

  onNext = () => {
    const { wizard } = this.props;
    wizard.setStep(wizard.next);
  };

  validateForm = termHasValidationError => {
    this.setState({ termHasValidationError });
  };

  createTerm = termInfo => {
    this.setState({ termInfo });
  };

  render() {
    const {
      t,
      flow: { shippingPricingTerm, selectedSkus }
    } = this.props;
    const { termHasValidationError } = this.state;

    const invalidConditionReason = t('createContract:messages.missingFieldsMessage');

    const description = t('createContract:shippingContract.description');

    return (
      <div>
        <StepTitle icon="truck-1-l" title={t('createContract:shippingContract.header')} description={description} />

        <ShippingTermCard
          className={singleCard}
          shippingPricingTerm={shippingPricingTerm}
          flow={this.props.flow}
          onCreateTerm={this.createTerm}
          skus={selectedSkus}
          validateForm={this.validateForm}
          checkTypeSelected={this.checkTypeSelected}
        />

        <WizardNavigator
          onPrev={this.onPrev}
          onNext={this.onNext}
          customNext={
            <Button
              className="btn btn-primary"
              disabled={termHasValidationError}
              disabledTooltipContents={invalidConditionReason}
              onClick={this.onNext}>
              {t('common:commonWords.next')}
            </Button>
          }
        />
      </div>
    );
  }
}

export default withWizard(withTranslation()(SetupShippingPricingTermStep));
